import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";
import {
    handleErrorByMessage,
    handleErrorNotPublished,
} from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("pricings.service");

export const pricingsService = {
    getTenantSlugFromDomain() {
        logger.trace("getTenantSlugFromDomain");
        return ajaxCall.get(`/ec2/tenant-slug`).catch(handleErrorByMessage());
    },
    getTenantPricingForRender(tenantSlug = "", { isEasyCart, isStorefront } = {}) {
        logger.trace("getTenantPricingForRender", tenantSlug);
        return ajaxCall
            .get(`/ec2/${tenantSlug}`, {
                params: { cart: isEasyCart, storefront: isStorefront },
            })
            .catch(handleErrorNotPublished());
    },
    getProductPricingForRender(
        tenantSlug = "",
        productSlug = "",
        { isEasyCart, isStorefront } = {}
    ) {
        return ajaxCall
            .get(`/ec2/${tenantSlug}/${productSlug}`, {
                params: { cart: isEasyCart, storefront: isStorefront },
            })
            .catch(handleErrorNotPublished());
    },
};

export const PRICING_HEADER_LAYOUTS = {
    standard: "standard",
    background: "background",
};

export const PRICING_LAYOUTS = {
    basic: "basic",
    grid: "grid",
    loop: "loop",
    list: "list",
    links: "links",
    shared: "shared",
    basicBottom: "basicBottom",
    gridBottom: "gridBottom",
};
